module.exports = __webpack_public_path__ + "static/ky-96d7cc25d02927518e551c27dc8c0372.svg";